// Form Builder
import {
  isEmail,
  isPhoneNumber,
  isNationalStockNumber,
  isUSZipCode,
} from '../../FormBuilder/validators';
import fiftyStates from '../../../config/fiftyStates.json';
import canadianProvinces from '../../../config/candianProvinces.json';
import PhoneNumber from '../../FormBuilder/CustomInputs/PhoneNumber';
import NationalStockNumber from '../../FormBuilder/CustomInputs/NationalStockNumber';
import ZipCode from '../../FormBuilder/CustomInputs/ZipCode';

export default {
  nationalStockNumber: {
    name: 'nationalStockNumber',
    displayName: 'National Stock Number',
    required: true,
    validators: [isNationalStockNumber],
    helpBlock:
      'Please enter a National Stock Number formatted as xxxx-xx-xxx-xxxx',
    type: 'custom',
    componentClass: NationalStockNumber,
  },
  partNumbers: {
    name: 'partNumbers',
    displayName: 'Part Numbers',
    type: 'array',
  },
  itemDescription: {
    name: 'itemDescription',
    displayName: 'Item Description',
    type: 'text',
  },
  solicitationNumber: {
    name: 'solicitationNumber',
    displayName: 'Solicitation Number',
    type: 'text',
  },
  companyName: {
    name: 'companyName',
    displayName: 'Company Name',
    required: true,
    type: 'text',
  },
  contactName: {
    name: 'contactName',
    displayName: 'Contact Name',
    required: true,
    type: 'text',
  },
  country: {
    name: 'country',
    displayName: 'Country',
    required: true,
    type: 'select',
    options: ['United States of America', 'Canada'],
  },
  mailingAddress: {
    name: 'mailingAddress',
    displayName: 'Mailing Address',
    required: true,
    type: 'text',
  },
  state: {
    name: 'state',
    displayName: 'State',
    required: true,
    type: 'select',
    options: Object.values(fiftyStates),
  },
  province: {
    name: 'province',
    displayName: 'Province',
    required: true,
    hidden: true,
    type: 'select',
    options: Object.values(canadianProvinces),
  },
  city: {
    name: 'city',
    displayName: 'City',
    required: true,
    type: 'text',
  },
  zipCode: {
    name: 'zipCode',
    displayName: 'ZIP Code',
    required: true,
    componentClass: ZipCode('american'),
    validators: [isUSZipCode],
    helpBlock: 'Please enter a 5 or 9 digit ZIP Code',
    type: 'custom',
  },
  phoneNumber: {
    name: 'phoneNumber',
    displayName: 'Phone Number',
    validators: [isPhoneNumber],
    helpBlock: 'Please enter a valid phone number formatted as xxx-xxx-xxxx',
    type: 'custom',
    componentClass: PhoneNumber,
  },
  phoneExt: { name: 'phoneExt', displayName: 'Phone Ext', type: 'text' },
  emailAddress: {
    name: 'emailAddress',
    displayName: 'Email Address',
    required: true,
    validators: [isEmail],
    helpBlock: 'Please enter a valid email address',
    type: 'text',
  },
  furtherAssistance: {
    name: 'furtherAssistance',
    displayName: 'Further Assistance',
    type: 'checkbox',
  },
};



// WEBPACK FOOTER //
// ./src/components/ToolingLocations/ToolingLocationsForm/formConfig.js